export const makeOptional = (optional) => (optional != null ? `/${optional}` : "")

export const deliveringTabsEnum = {
  candidateReview: "candidate-review",
  invigilation: "invigilation",
  schedule: "schedule",
}

export const markingTabsEnum = {
  candidateResults: "candidateResults",
  coordinator: "coordinator",
  reScoring: "reScoring",
  remarking: "remarking",
  reviewSessions: "reviewSessions",
  toBeAssessed: "toBeAssessed",
}

export const markingRolesEnum = {
  assessing: "assessing",
  moderation: "moderation",
}

export const getMarkingRole = (role) => {
  switch (role) {
    case 1:
      return markingRolesEnum.assessing
    case 2:
      return markingRolesEnum.moderation
    default:
      return null
  }
}

export const deliveringTabs = Object.values(deliveringTabsEnum)
export const markingRoles = Object.values(markingRolesEnum)

export const getDeliveringTab = (profile) => {
  if (profile.Schedule) return deliveringTabsEnum.schedule
  if (profile.Invigilation) return deliveringTabsEnum.invigilation
  if (profile.ViewReviewSessionTab) return deliveringTabsEnum.candidateReview
  return ""
}

export const markingTabs = Object.values(markingTabsEnum)

export const getMarkingTab = (profile) => {
  if (profile.ManageAssessors) return markingTabsEnum.coordinator
  if (profile.ViewAssessTab) return markingTabsEnum.toBeAssessed
  if (profile.ViewResultsTab) return markingTabsEnum.candidateResults
  if (profile.ViewReScoringTab) return markingTabsEnum.reScoring
  if (profile.ViewReviewSessionTab) return markingTabsEnum.reviewSessions
  if (profile.ViewRemarkingTab) return markingTabsEnum.remarking
  return ""
}
